import type { QueryClient } from '@tanstack/react-query'

// A query's own `retry` replaces the app-wide policy, so this keeps the
// QueryClient default and only adds "never retry this particular error".
export function retryUnless(queryClient: QueryClient, stop: (err: unknown) => boolean) {
  return (failureCount: number, err: unknown): boolean => {
    if (stop(err)) return false
    const fallback = queryClient.getDefaultOptions().queries?.retry
    if (typeof fallback === 'function') return fallback(failureCount, err as Error)
    if (typeof fallback === 'number') return failureCount < fallback
    if (fallback === false) return false
    return failureCount < 3
  }
}
